module.exports = __webpack_public_path__ + "static/media/santander-logo.f7052ab3.png";